export const AlignType = {
    DEFAULT: "",
    CENTER: "center",
    LEFT: "left",
    RIGTH: "right",
};